import { History } from 'history';
import React, { memo, ReactNode, useLayoutEffect, useState } from 'react';
import { Router } from 'react-router';

/** Binds the React Router tree to the shared browser history instance. */
export interface Props {
  /** Optional base path when the app is mounted under a subdirectory. */
  basename?: string;
  /** Shared history object used by the router and navigation middleware. */
  history: History;
  /** Route content rendered inside the history-aware router. */
  children?: ReactNode;
}
const HistoryRouterBase = (props: Props): JSX.Element => {
  const {
    basename,
    children,
    history
  } = props;
  const [historyState, setHistoryState] = useState({
    action: history.action,
    location: history.location
  });
  useLayoutEffect(() => history.listen(setHistoryState), [history]);
  return <Router basename={basename} location={historyState.location} navigationType={historyState.action} navigator={history} data-sentry-element="Router" data-sentry-component="HistoryRouterBase" data-sentry-source-file="history-router.tsx">
            {children}
        </Router>;
};

/**
 * Keeps React Router synchronized with the shared browser history object.
 *
 * @param props History router configuration and rendered children.
 * @returns A router instance bound to the shared history object.
 *
 * @example
 * <HistoryRouter history={history}>{children}</HistoryRouter>
 */
export const HistoryRouter = memo(HistoryRouterBase);